export enum Period {
	yearToDate = "yearToDate",
	last12month = "last12month",
	customDate = "customDate",
}

export interface SelectedPeriod {
	period: Period;
	startDate: string;
	endDate: string;
}

export interface PeriodStatus {
	status: boolean;
	errorMessage: string;
	selectedPeriod?: SelectedPeriod;
}
